'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _MatrixClientPeg = require('../../MatrixClientPeg');

var _MatrixClientPeg2 = _interopRequireDefault(_MatrixClientPeg);

var _index = require('../../index');

var _index2 = _interopRequireDefault(_index);

var _ContentMessages = require('../../ContentMessages');

var _ContentMessages2 = _interopRequireDefault(_ContentMessages);

var _languageHandler = require('../../languageHandler');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UploadButton = function (_React$Component) {
    (0, _inherits3.default)(UploadButton, _React$Component);

    function UploadButton(props, context) {
        (0, _classCallCheck3.default)(this, UploadButton);

        var _this = (0, _possibleConstructorReturn3.default)(this, (UploadButton.__proto__ || (0, _getPrototypeOf2.default)(UploadButton)).call(this, props, context));

        _this.onUploadClick = _this.onUploadClick.bind(_this);
        _this.onUploadFileInputChange = _this.onUploadFileInputChange.bind(_this);
        return _this;
    }

    (0, _createClass3.default)(UploadButton, [{
        key: 'onUploadClick',
        value: function onUploadClick(ev) {
            if (_MatrixClientPeg2.default.get().isGuest()) {
                dis.dispatch({ action: 'require_registration' });
                return;
            }
            this.refs.uploadInput.click();
        }
    }, {
        key: 'onUploadFileInputChange',
        value: function onUploadFileInputChange(ev) {
            if (ev.target.files.length === 0) return;

            // take a copy so we can safely reset the value of the form control
            // (Note it is a FileList: we can't use slice or sesnible iteration).
            var tfiles = [];
            for (var i = 0; i < ev.target.files.length; ++i) {
                tfiles.push(ev.target.files[i]);
            }

            _ContentMessages2.default.sharedInstance().sendContentListToRoom(tfiles, this.props.roomId, _MatrixClientPeg2.default.get());

            // This is the onChange handler for a file form control, but we're
            // not keeping any state, so reset the value of the form control
            // to empty.
            // NB. we need to set 'value': the 'files' property is immutable.
            ev.target.value = '';
        }
    }, {
        key: 'render',
        value: function render() {
            var uploadInputStyle = { display: 'none' };
            var AccessibleButton = _index2.default.getComponent('elements.AccessibleButton');
            return _react2.default.createElement(
                AccessibleButton,
                { className: 'mx_MessageComposer_button mx_MessageComposer_upload',
                    onClick: this.onUploadClick,
                    title: (0, _languageHandler._t)('Upload file')
                },
                _react2.default.createElement('input', { ref: 'uploadInput', type: 'file',
                    style: uploadInputStyle,
                    multiple: true,
                    onChange: this.onUploadFileInputChange
                })
            );
        }
    }]);
    return UploadButton;
}(_react2.default.Component);

UploadButton.propTypes = {
    roomId: _propTypes2.default.string.isRequired
};
exports.default = UploadButton;
module.exports = exports['default'];
//# sourceMappingURL=UploadButton.js.map